import SignupForm from "@/modules/auth/register/ui/components/SignupForm"
import { SignupAd } from "../components/SignupAd"

export default function SignupPage() {
  return (
    <div className="force-light bg-background text-foreground flex flex-col md:flex-row w-full min-h-screen">
      <SignupAd />
      <div className="flex-1 flex items-center justify-center pr-4 sm:pr-8 md:pr-8 md:pl-30 max-md:pl-4">
        <div className="w-full">
          <SignupForm />
        </div>
      </div>
    </div>
  )
}
